import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { useForgotPassword } from "@/api/auth";
import { getApiErrorMessage } from "@/api/client";

interface FormValues {
  email: string;
}

export default function ForgotPasswordPage() {
  const { register, handleSubmit } = useForm<FormValues>();
  const forgotPassword = useForgotPassword();

  const onSubmit = async (values: FormValues) => {
    try {
      const res = await forgotPassword.mutateAsync(values);
      toast.success(res.message || "Revise su correo para continuar.");
    } catch (error) {
      toast.error(getApiErrorMessage(error));
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="card max-w-md w-full p-8">
        <h1 className="text-xl font-semibold text-gray-900">Recuperar contraseña</h1>
        <p className="mt-1 text-sm text-gray-500">
          Ingrese su correo electrónico y le enviaremos instrucciones para restablecer su contraseña.
        </p>

        <form className="mt-6 space-y-4" onSubmit={handleSubmit(onSubmit)} noValidate>
          <div>
            <label className="block text-sm font-medium text-gray-700" htmlFor="email">
              Correo electrónico
            </label>
            <input id="email" type="email" className="input-field mt-1" {...register("email", { required: true })} />
          </div>

          <button type="submit" className="btn-primary w-full" disabled={forgotPassword.isPending}>
            {forgotPassword.isPending ? "Enviando..." : "Enviar instrucciones"}
          </button>
        </form>

        <p className="mt-4 text-center text-sm">
          <Link to="/login" className="text-brand-600 hover:text-brand-700">
            Volver a iniciar sesión
          </Link>
        </p>
      </div>
    </div>
  );
}
